import { render } from "./CheckoutForm.vue?vue&type=template&id=ded042b4&scoped=true"
import script from "./CheckoutForm.vue?vue&type=script&lang=js"
export * from "./CheckoutForm.vue?vue&type=script&lang=js"

import "./CheckoutForm.vue?vue&type=style&index=0&id=ded042b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded042b4"]])

export default __exports__